import { Link, useLocation } from "react-router-dom";
import "./ContactMessage.scss";
import { googleEvent_LOJ028 } from "../../lib/google-analytics";

export default function ContactMessage() {
  const { pathname } = useLocation();

  const handleContactEvent = () => {
    switch (pathname) {
      case "/enter-aadhar":
        googleEvent_LOJ028();
        break;

      default:
        return "";
    }
  };

  return (
    <div className="contact-message">
      Facing any issue?{" "}
      <Link to="/contact-us" onClick={handleContactEvent}>
        Contact us
      </Link>
    </div>
  );
}
